import type { InjectionKey, Ref } from 'vue';

export const globalFilterKey = Symbol('jk/globalFilterKey') as InjectionKey<Ref<Record<string, unknown>>>;

export default globalFilterKey;
